import React from "react";

import { formatNumber, getVariance } from "utils";

import { Card, Col, MapInteractive, Typography } from "components";

export const DigifarmMap = ({ digifarmArea, digifarmShape, field, getFieldMarker, setDigifarmArea }) => (
  <>
    <Col sm={24} md={12}>
      <Typography variant="h4">Digifarm polygon</Typography>
      <Typography variant="paragraph-m">
        {digifarmArea ? formatNumber({ number: digifarmArea, decimalPlaces: 4 }) : 0}
        ha ({digifarmArea ? getVariance(field.size, digifarmArea, 2) : 0}% variance)
      </Typography>
      <Card className="map-card">
        <MapInteractive
          field={field}
          geometry={{
            geometry: digifarmShape,
          }}
          location={field.location}
          markers={[
            {
              location: getFieldMarker(field).location,
              name: getFieldMarker(field).name,
            },
          ]}
          scaleControl={true}
          updateArea={(area) => setDigifarmArea(area)}
          zoomControl={true}
        />
      </Card>
    </Col>
  </>
);
